export default __webpack_public_path__ + "static/media/thienha.bc1f3073.jpg";